/* eslint-disable no-console */
import {Flex} from 'antd';
import React, {memo} from 'react';

import {ReactComponent as PercentDown} from '../../../assets/percent_down.svg';
import {ReactComponent as PercentUp} from '../../../assets/percent_up.svg';
import BoxContent from '../../../components/BoxContent/BoxContent';
import ProgressChart from '../../../components/Chart/PieCharts/ProgressChart';
import InfoTooltip from '../../../components/InfoTooltip/InfoTooltip';
// import Progress from '../../../components/ProgressIndicator/Progress';
import {convertPxToRem} from '../../../utils/commonFunctions';
import {formatIndian} from '../../../utils/formatIndian';
// import {roundToDecimal} from '../constants/commonFunctions';

const ValueRepresentationBox: React.FC<{
  data: any;
  mainKey: string;
  showTotal?: boolean;
  smallImage?: boolean;
  tooltip?: string;
  labelType?: 'value' | 'percent';
  isCost?: boolean;
  customLabel?: string;
  valueType?: 'string' | 'number';
  checkSingle?: boolean;
}> = ({
  data,
  mainKey,
  showTotal = true,
  smallImage = false,
  tooltip,
  labelType = 'value',
  isCost = false,
  customLabel = '',
  valueType = 'number',
  checkSingle = true
}) => {
  const mainData = data?.find((item: any) => {
    return item?.dataId === mainKey;
  });

  const negPos = mainData?.percentage?.toString().startsWith('-')
    ? 'negative'
    : 'positive';

  return (
    <BoxContent>
      <Flex
        className="valueBox"
        vertical={true}
        justify="space-between"
        align="center"
      >
        {mainData?.image !== 'NA' ? (
          <Flex justify="space-between" align="center" style={{width: '100%'}}>
            <img
              src={mainData?.image}
              className={`img ${smallImage ? 'small' : 'big'}`}
              style={{alignSelf: 'flex-start'}}
            />
            {tooltip && (
              <div style={{alignSelf: 'baseline'}}>
                <InfoTooltip
                  message={tooltip}
                  autoAdjustOverflow={true}
                  arrow={true}
                />
              </div>
            )}
          </Flex>
        ) : (
          <Flex justify="space-between" style={{width: '100%'}}>
            <div
              style={{height: convertPxToRem(120), width: convertPxToRem(120)}}
            >
              <ProgressChart
                data={[mainData]}
                mainData={mainData}
                labelType={labelType}
                customLabel={customLabel}
                checkSingle={checkSingle}
              />
            </div>
            {tooltip && (
              <div style={{alignSelf: 'baseline'}}>
                <InfoTooltip
                  message={tooltip}
                  autoAdjustOverflow={true}
                  arrow={true}
                />
              </div>
            )}
          </Flex>
        )}
        {showTotal && (
          <div className="value" style={{alignSelf: 'flex-start'}}>
            {isCost && <span>{`${mainData?.unit} `}</span>}
            {`${
              valueType === 'string'
                ? mainData?.value
                : formatIndian(mainData?.value) ?? ''
            } `}
            {!isCost && <span>{mainData?.unit}</span>}
          </div>
        )}
        <div className="title" style={{alignSelf: 'flex-start'}}>
          {mainData?.label ?? ''}
        </div>
        {mainData?.percentage && (
          <div
            className={`percentageBox ${negPos}`}
            style={{alignSelf: 'flex-start'}}
          >
            {negPos === 'positive' ? <PercentUp /> : <PercentDown />}
            <div>
              {mainData?.percentage
                ? `${mainData?.percentage.toString().replace('-', '')} `
                : ''}
            </div>
            <div>%</div>
          </div>
        )}
      </Flex>
    </BoxContent>
  );
};

export default memo(ValueRepresentationBox);
